(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.iComply",
                {
                    url: "/iComply",
                    component: "icomply",
                    PageTitle: "iComply",
                    requiredPermissions: "IComply:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("icomply",
        {
            templateUrl: "App/Resources/iComply/icomply.html",
            controller: icomplyCtrl,
            bindings: {
                states: "<"               
            }
        });

    icomplyCtrl.$inject = ["$http", "eligibilityFormDialog", "surveys", "eligibilityFormApi", "permissionService", "iComplySettings", "iComplyApi", "externalLoading", "amplitudeService"];

    function icomplyCtrl($http, eligibilityFormDialog, surveys, eligibilityFormApi, permissionService, iComplySettings, iComplyApi, externalLoading, amplitudeService) {
        var $ctrl = this;
        window.o = this;
        surveys.then(function (s) {
            eligibilityFormApi.isEnrolled(s.iComplyId).then(function (submitted) {               
                $ctrl.submitted = submitted;
            });
        });

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.iComplyId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        };
        
        $ctrl.redirectToIcomply = function () {
            var w = window.open();
            w.document.write(externalLoading.html);
            iComplyApi.getToken().then(function (result) {
                var auth = JSON.parse(result.Auth);
                var url = iComplySettings.baseUrl +
                    "/Sso?accesstoken=" + auth.Token +
                    "&expiration=" + auth.Expiration;

                if (result.OnBehalfOfUserFigAuthId != null) {
                    url += "&onbehalfofauthuserid=" + result.OnBehalfOfUserFigAuthId;
                }

                console.log(url)
                w.location.href = url;
            },
                function error(x) {
                    console.log(x);
                    $ctrl.ssoError = true;
                    w.close();
                });
        };

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
    }
})(window.app, window.angular); // jshint ignore:line